export default "__VITE_ASSET__IM0sOIR$__"